import { DropdownMenuItem } from '@vg-constellation/angular-17/dropdown';
import { BeneficiaryType } from '../types/BeneficiaryType';

export interface DropdownStateChangeEvent {
  activeItems?: string[];
}

export type BeneficiarySectionType = 'PRIMARY' | 'CONTINGENT';

export interface BeneficiarySelection {
  householdMemberId: string | null;
  firstName: string;
  lastName: string;
  dateOfBirth: string; // YYYY-MM-DD format (from ZOK API and c11n-date-picker)
  stateOfResidence: string;
  type: BeneficiarySectionType; // UI uses "backup" label but MEZ API expects 'CONTINGENT'
  distributionPercentage: number;
  // Derived from householdMemberId === null. Kept explicit for readability in ZOK creation guards.
  isNew: boolean;
  beneficiaryType: BeneficiaryType;
}

export interface BeneficiaryState {
  primaryBeneficiaries: BeneficiarySelection[];
  backupBeneficiaries: BeneficiarySelection[];
}

export function createEmptyBeneficiaryState(): BeneficiaryState {
  return {
    primaryBeneficiaries: [],
    backupBeneficiaries: []
  };
}

export function calculateDistributionTotal(beneficiaries: BeneficiarySelection[]): number {
  return beneficiaries.reduce((sum, b) => sum + (b.distributionPercentage || 0), 0);
}

// sm breakpoint: ≥576px uses medium density (24px padding), <576px uses small (16px padding)
export function getCardDensity(): 'small' | 'medium' {
  return window.innerWidth < 576 ? 'small' : 'medium';
}

export const US_STATES_AND_TERRITORIES: DropdownMenuItem[] = [
  { labelText: 'Alabama', id: 'AL' },
  { labelText: 'Alaska', id: 'AK' },
  { labelText: 'Arizona', id: 'AZ' },
  { labelText: 'Arkansas', id: 'AR' },
  { labelText: 'California', id: 'CA' },
  { labelText: 'Colorado', id: 'CO' },
  { labelText: 'Connecticut', id: 'CT' },
  { labelText: 'Delaware', id: 'DE' },
  { labelText: 'Florida', id: 'FL' },
  { labelText: 'Georgia', id: 'GA' },
  { labelText: 'Hawaii', id: 'HI' },
  { labelText: 'Idaho', id: 'ID' },
  { labelText: 'Illinois', id: 'IL' },
  { labelText: 'Indiana', id: 'IN' },
  { labelText: 'Iowa', id: 'IA' },
  { labelText: 'Kansas', id: 'KS' },
  { labelText: 'Kentucky', id: 'KY' },
  { labelText: 'Louisiana', id: 'LA' },
  { labelText: 'Maine', id: 'ME' },
  { labelText: 'Maryland', id: 'MD' },
  { labelText: 'Massachusetts', id: 'MA' },
  { labelText: 'Michigan', id: 'MI' },
  { labelText: 'Minnesota', id: 'MN' },
  { labelText: 'Mississippi', id: 'MS' },
  { labelText: 'Missouri', id: 'MO' },
  { labelText: 'Montana', id: 'MT' },
  { labelText: 'Nebraska', id: 'NE' },
  { labelText: 'Nevada', id: 'NV' },
  { labelText: 'New Hampshire', id: 'NH' },
  { labelText: 'New Jersey', id: 'NJ' },
  { labelText: 'New Mexico', id: 'NM' },
  { labelText: 'New York', id: 'NY' },
  { labelText: 'North Carolina', id: 'NC' },
  { labelText: 'North Dakota', id: 'ND' },
  { labelText: 'Ohio', id: 'OH' },
  { labelText: 'Oklahoma', id: 'OK' },
  { labelText: 'Oregon', id: 'OR' },
  { labelText: 'Pennsylvania', id: 'PA' },
  { labelText: 'Rhode Island', id: 'RI' },
  { labelText: 'South Carolina', id: 'SC' },
  { labelText: 'South Dakota', id: 'SD' },
  { labelText: 'Tennessee', id: 'TN' },
  { labelText: 'Texas', id: 'TX' },
  { labelText: 'Utah', id: 'UT' },
  { labelText: 'Vermont', id: 'VT' },
  { labelText: 'Virginia', id: 'VA' },
  { labelText: 'Washington', id: 'WA' },
  { labelText: 'West Virginia', id: 'WV' },
  { labelText: 'Wisconsin', id: 'WI' },
  { labelText: 'Wyoming', id: 'WY' },
  { labelText: 'Outside the United States', id: 'OUTSIDE_US' },
];
